import { Toggle as TailGridsToggle } from '../tailgrids/core/toggle.js';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Names the switch for screen readers when there is no visible `label`. */
  'aria-label'?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

/** An on/off switch that applies immediately (NextAdmin toggle). Inside a form use `SwitchField` instead. */
export function Toggle({ checked, onChange, label, disabled = false, size = 'md', ...aria }: ToggleProps) {
  return (
    <TailGridsToggle
      role="switch"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      label={label}
      aria-label={aria['aria-label']}
      disabled={disabled}
      size={size}
    />
  );
}
